import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import { Card } from '@radix-ui/themes';
import React, { useEffect, useRef } from 'react';
import styles from './FlippableCard.module.css';

type Props = {
  FrontComponent: React.ReactNode;
  BackComponent: React.ReactNode;
};

export default function FlippableCard(props: Props) {
  const [flipped, setFlipped] = React.useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      if (flipped) ref.current.style.transform = 'rotateY(180deg)';else
      ref.current.style.transform = '';
    }
  }, [flipped, ref]);

  function toggleFlip() {
    setFlipped((prevState) => !prevState);
  }

  return (
    <div className={styles.card}>
			<div className={styles.content} ref={ref}>
				<div className={styles.front}>
					<Card className="flex h-full flex-col">
						<CardFlipButton onClick={toggleFlip} />
						{props.FrontComponent}
					</Card>
				</div>
				<div className={styles.back}>
					<Card className="h-full pb-2">
						<CardFlipButton onClick={toggleFlip} />
						<div className="h-full overflow-y-scroll pb-2">{props.BackComponent}</div>
					</Card>
				</div>
			</div>
		</div>);

}

const CardFlipButton = ({ onClick }: {onClick: () => any;}) => {
  return (
    <div className="flex flex-1 justify-end">
			<QuestionMarkCircleIcon
        height="1.5rem"
        width="1.5rem"
        className="cursor-pointer hover:fill-white/20"
        onClick={onClick} />

		</div>);

};